import React from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import CustomInput from '../../components/TextField/TextFeild';
// import { changeFormStep, submitRegistration } from '../store/registrationSlice';
import CountryCodeDropdown from '../../components/CountryDropDown/CountryDropDown';
import { changeFormStep, updateFormData } from '../../store/slices/registrationSlice';

const RegistrationConfirm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const initialValues = {
        id: queryParams.get('email') || '',
        attributes: {
            inviteToken: queryParams.get('q') || '',
            firstName: queryParams.get('firstName') || '',
            lastName: queryParams.get('lastName') || '',
            stationGroupId: Number(queryParams.get('sgv')) || 0,
            phone: '',
            password: '',
            passwordRepeat: '',
            agree: false
        },
        completed: [false, false, false, false, false]
    };

    const validate = (values) => {
        const errors = {};
        // Required fields validation
        if (!values.id) errors.id = 'Email is required';
        if (!values.attributes.phone) errors.phone = 'Phone number is required';
        if (!values.attributes.password) errors.password = 'Password is required';
        if (!values.attributes.passwordRepeat) errors.passwordRepeat = 'Please repeat your password';

        // Password length validation
        if (values.attributes.password && values.attributes.password.length < 8) {
            errors.password = 'Must be at least 8 characters long';
        }

        // Password match validation
        if (values.attributes.password !== values.attributes.passwordRepeat) {
            errors.passwordRepeat = 'Passwords must match';
        }

        // Phone validation
        if (!values.attributes.phone) {
            errors.phone = 'Must be a valid mobile phone number';
        }

        return errors;
    };

    const formik = useFormik({
        initialValues,
        validate,
        onSubmit: async (values, { setSubmitting, setErrors }) => {
            if (!values.attributes.agree) {
                setErrors({ _error: 'You must agree to our ToS' });
                setSubmitting(false);
                return;
            }
            try {
                dispatch(updateFormData(values));
                dispatch(changeFormStep({ step: 0, completed: true }));
                navigate('/setup/1');
            } catch (error) {
                setErrors({ _error: error.message });
                setSubmitting(false);
            }
        }
    });

    const handleCountryChange = (phoneNumber) => {
        formik.setFieldValue('attributes.phone', phoneNumber);
    };

    const greeting = [formik.values.attributes.firstName, formik.values.attributes.lastName]
        .filter(Boolean)
        .join(' ') || 'Stranger';

    const joinRFXLabel = (
        <span style={{ fontWeight: 'normal' }}>Join Group</span>
    );

    return (
        <div className="loginBox">
            <div className="HeadingText">
                <p>Control Panel</p>
            </div>
            <div className="card">
                <div className="card-body px-0">
                    <div className="cardText">
                        <p className="heading pt-2">Hey, {initialValues.attributes.firstName} {initialValues.attributes.lastName}!</p>
                        <p className="h6 pt-4">Let's start with creating your password:</p>
                    </div>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="FormDiv  pt-4">
                            <CustomInput
                                label="Email"
                                type="email"
                                id="id"
                                name="id"
                                value={formik.values.id}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.id && formik.errors.id}
                                required
                            />
                            <div className="custom-form-group d-flex justify-space-between setup-phone-field">
                                <CountryCodeDropdown
                                    label="Personal Phone Number"

                                    phoneNumber={formik.values.attributes.phone}
                                    onPhoneNumberChange={handleCountryChange}
                                />
                                <hr
                                    className={
                                        formik.touched.attributes?.phone && formik.errors.phone
                                            ? "error-hr-line"
                                            : ""
                                    }
                                />
                                {formik.touched.attributes?.phone && formik.errors.phone ? (
                                    <div className="error-text">{formik.errors.phone}</div>
                                ) : null}
                            </div>
                            <CustomInput
                                label="Password"
                                type="password"
                                id="password"
                                name="attributes.password"
                                value={formik.values.attributes.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.attributes?.password && formik.errors.password}
                                required
                            />

                            <CustomInput
                                label="Repeat Password"
                                type="password"
                                id="passwordRepeat"
                                name="attributes.passwordRepeat"
                                value={formik.values.attributes.passwordRepeat}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.attributes?.passwordRepeat && formik.errors.passwordRepeat}
                                required
                            />

                        </div>
                        <div style={{
                            textAlign: 'left',
                            marginTop: 30,
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center'
                        }}>
                            <input
                                type="checkbox"
                                id="agree"
                                checked={formik.values.attributes.agree}
                                onChange={(e) => formik.setFieldValue('attributes.agree', e.target.checked)}
                                style={{ marginRight: 5 }}
                            />
                            <label htmlFor="agree" style={{
                                fontSize: '10px',
                                textTransform: 'uppercase',
                                color: '#9e9e9e',
                                whiteSpace: 'nowrap'
                            }}>
                                I agree with&nbsp;
                                <Link to="#" target="_blank" style={{ color: '#9e9e9e', textDecoration: 'underline' }}>
                                    terms and conditions
                                </Link>
                            </label>
                        </div>

                        {formik.errors._error && (
                            <div style={{ color: 'red', textAlign: 'left', marginTop: 10 }}>
                                {formik.errors._error}
                            </div>
                        )}

                        <div className="btnDiv mt-5 text-center">
                            <button type="submit" className="default-btn">
                                <span>Join Group</span>
                            </button>
                        </div>
                        
                    </form>
                </div>
            </div>
        </div>
    );
};

export default RegistrationConfirm;